import { ComponentRef, Directive, EmbeddedViewRef, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { TableSkeletonComponent } from '../components/table-skeleton/table-skeleton.component';
import { LoadingService } from '../service/loading.service';
import { TableDataColumn } from '@shared/ui/tables';
@Directive({
  selector: '[featureLoadingTableSkeleton]',
  standalone: false,
})
export class TableSkeletonDirective implements OnInit, OnDestroy, OnChanges {
  @Input('featureLoadingTableSkeleton') columns = 0;
  @Input('featureLoadingTableSkeletonColumnNames') columnNames: TableDataColumn[] = [];
  @Input('featureLoadingTableSkeletonUrl') url = '';
  @Input('featureLoadingTableSkeletonIsLoading') isLoading = true;
  @Input('featureLoadingTableSkeletonRows') rows = 10;

  private ngUnsubscribe = new Subject<void>();
  private view: EmbeddedViewRef<unknown>;
  private skeletonView?: ComponentRef<TableSkeletonComponent>;
  private initialLoadPassed = false;
  constructor(private tpl: TemplateRef<unknown>, private vcr: ViewContainerRef, public loading: LoadingService) {
    this.view = this.vcr.createEmbeddedView(this.tpl);
    for (let i = 0; i < this.view.rootNodes[0].children.length; i++) {
      this.view.rootNodes[0].children[i].classList.add('hidden-content');
    }
  }

  ngOnInit(): void {
    this.skeletonView = this.vcr.createComponent(TableSkeletonComponent);
    this.skeletonView.instance.columnsCount = this.columns;
    this.skeletonView.instance.columnNames = this.columnNames;
    this.skeletonView.instance.numberOfRows = this.rows;
    const skeletonViewRoot: HTMLElement | null = this.skeletonView.location.nativeElement;
    if (skeletonViewRoot) {
      skeletonViewRoot.style.display = 'block';
    }
  }

  ngOnChanges(): void {
    const skeletonViewRoot: HTMLElement | null = this.skeletonView?.location.nativeElement;
    if (this.isLoading) {
      for (let i = 0; i < this.view.rootNodes[0].children.length; i++) {
        this.view.rootNodes[0].children[i].classList.add('hidden-content');
      }
      if (skeletonViewRoot) {
        skeletonViewRoot.style.display = 'block';
      }
      this.initialLoadPassed = true;
    }
    if (!this.isLoading && this.initialLoadPassed) {
      if (skeletonViewRoot) {
        skeletonViewRoot.style.display = 'none';
      }
      for (let i = 0; i < this.view.rootNodes[0].children.length; i++) {
        this.view.rootNodes[0].children[i].classList.remove('hidden-content');
      }
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
